module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    ref: "menuNav",
    staticClass: "navbar-default navbar-static-side "
  }, [_c('div', {
    staticClass: "sidebar-collapse"
  }, [_c('div', {
    staticClass: "menu-header"
  }, [_c('div', {
    staticClass: "logo-area",
    on: {
      "click": _vm.goToProfile
    }
  }, [(_vm.user.avatar && _vm.user.avatar.url) ? _c('img', {
    staticClass: "img-circle w80",
    attrs: {
      "alt": "image",
      "src": _vm.user.avatar.url
    }
  }) : _c('img', {
    staticClass: "img-circle w80",
    attrs: {
      "alt": "image",
      "src": require("../../../common/assets/img/avatar.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-area"
  }, [_c('div', {
    staticClass: "nickname"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.user.nickname) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "role"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.user.role.name) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.user.byMenus), function(menu, index) {
    return _c('SideMenu', {
      key: index,
      attrs: {
        "menu": menu
      }
    })
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0a20f97a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/layout/Navigation.vue
// module id = 948
// module chunks = 1